import React, { useEffect, useState } from "react";
import { Script } from "gatsby";

const DynamicsScriptLoader = () => {
    const [scriptLoaded, setScriptLoaded] = useState<boolean>(false);

    if (!scriptLoaded) {
        setScriptLoaded(true);
    }

    useEffect(() => {
        return () => {
            setScriptLoaded(false);
        };
    }, []);

    return scriptLoaded ? (
        <Script src="https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/eur/FormCapture/FormCapture.bundle.js" />
    ) : null;
};

export default DynamicsScriptLoader;
